<ppb-start-container [width]="'wide'">
  <div>
    <form
      [formGroup]="accountForm"
      autocomplete="off"
      (ngSubmit)="handleSubmit()"
    >
      <h3 class="login-title"
          i18n="@@account.account_registration"
      >Zarejestruj się</h3>
      <div class="o-form-group u-width-250">
        <pseic-form-field
          label="Imię"
          labelFor="firstName"
          i18n-label="@@common.first_name"
        >
          <input
            class="o-form-field"
            id="firstName"
            type="text"
            formControlName="firstName"
            required
          >
        </pseic-form-field>
      </div>
      <div class="o-form-group u-width-250">
        <pseic-form-field
          label="Nazwisko"
          labelFor="lastName"
          i18n-label="@@common.last_name"
        >
          <input
            class="o-form-field"
            id="lastName"
            type="text"
            formControlName="lastName"
            required
          >
        </pseic-form-field>
      </div>
      <div class="o-form-group u-width-250">
        <pseic-form-field
          label="E-mail"
          labelFor="email"
          i18n-label="@@common.email"
        >
          <input
            class="o-form-field"
            id="email"
            type="text"
            formControlName="email"
            required
          >
        </pseic-form-field>
      </div>
      <pseic-phone [phoneForm]="accountForm.get('phone')"></pseic-phone>
      <div class="o-form-check__custom">
        <pseic-form-checkbox
          [formGroup]="accountForm"
          controlName="sharePhone"
        >
          <span i18n="@@account.share_phone"
          >Udostępnij nr telefonu Administratorom Bezpieczeństwa Partnera Biznesowego</span>
          <psei-icon
            name="circle-danger"
            [size]="iconSize"
            class="icon-hint"
            [pseiTooltip]="TooltipRef"
            [delay]="delay">
          </psei-icon>
        </pseic-form-checkbox>
      </div>
      <div class="o-form-group u-width-200">
        <pseic-form-field
          label="Kod rejestracyjny"
          labelFor="registrationCode"
          i18n-label="@@registration-codes.registration_code"
        >
          <input
            class="o-form-field"
            id="registrationCode"
            type="text"
            formControlName="code"
            required
          >
        </pseic-form-field>
      </div>
      <div class="o-form-check__custom">
        <pseic-form-checkbox
          [formGroup]="accountForm"
          controlName="rulesAgreement"
        >
          <span i18n="@@account.rules_agreement">Oświadczam, że zapoznałem się z treścią <a
            href="{{configuration.agreements.rulesUrl}}" target="_blank">
          Regulaminu Portalu Partnera Biznesowego</a> i&nbsp;akceptuję jego postanowienia.</span>
        </pseic-form-checkbox>
      </div>
      <div class="o-form-check__custom">
        <pseic-form-checkbox
          [formGroup]="accountForm"
          controlName="privacyPolicyAgreement"
        >
          <span i18n="@@account.policies_agreement">Oświadczam, że zapoznałem się i akceptuję <a
            href="{{configuration.agreements.policiesUrl}}" target="_blank">Politykę
          prywatności</a>.</span>
        </pseic-form-checkbox>
      </div>
      <div *ngIf="finished"
           class="confirm-message"
           i18n="@@account.confirm_message"
      >
        Na adres adres mailowy {{email}} wysłano mail aktywacyjny.
        <br>Sprawdź skrzynkę odbiorczą.
      </div>
      <div *ngIf="!finished"
           fxLayout="row"
           fxLayoutAlign="end center"
           fxLayoutGap="24px"
      >
        <pseic-async-button
          [type]="ButtonType.BUTTON"
          [isLoading$]="isLoading$"
          [flavor]="'SECONDARY'"
          (buttonClicked)="handleBackClick()"
          i18n="@@common.cancel"
        >Anuluj
        </pseic-async-button>
        <pseic-async-button
          [type]="ButtonType.SUBMIT"
          [isDisabled$]="isDisabled$"
          [isLoading$]="isLoading$"
          (buttonClicked)="submitNewAccount()"
          i18n="@@account.register"
        >Rejestruj
        </pseic-async-button>
      </div>
      <div *ngIf="finished"
           fxLayout="row"
           fxLayoutAlign="end stretch"
      >
        <div>
          <button class="o-btn o-btn--primary o-btn--small"
                  type="button"
                  routerLink="/"
                  i18n="@@common.go_to_home_page"
          >Powrót do strony głównej
          </button>
        </div>
      </div>
    </form>
  </div>
</ppb-start-container>

<ng-template #TooltipRef>
  <div class="u-width-500">
   <span
     i18n="@@account.show_share_phone_hint">
            Udostępnienie numeru telefonu jest zalecane w celu ułatwienia kontaktu Administratorom Partnera Biznesowego.
            Po rejestracji konta zgodę na udostępnianie numeru telefonu możesz w każdej chwili samodzielnie wycofać z poziomu formatki z danymi Twojego konta.
          </span>
  </div>
</ng-template>
